import { required, useNotify, useRefresh } from "react-admin";
import CheckIcon from "@mui/icons-material/Check";
import { Grid, Button } from "@mui/material";
import FormModal from "server/components/Modals/FormModal";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { erasmusRequests } from "api/erasmusApi";
import dataProvider from "server/dataProvider";
import { toDateOnly } from "utils/helpers";

const CheckFinishedModal = ({ label = "Приключил" }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const defaultValues = { departureDate: toDateOnly(new Date().toISOString()) };

  const handleSent = async data => {
    const confirmData = { departureDate: toDateOnly(data.departureDate) };
    await dataProvider.customRequest(erasmusRequests.finishIncomingStudentsRegular(data?.id), confirmData, "POST");
    refresh();
    notify(`Успешна редакция`, { type: "success" });
  };

  return (
    <FormModal
      titleContent={"Приключване на Еразъм"}
      defaultValues={defaultValues}
      onConfirm={handleSent}
      startIcon={<CheckIcon />}
      triggerButton={
        <Button
          variant="contained"
          startIcon={<CheckIcon />}
        >
          {label}
        </Button>
      }
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <CustomDateInput
            source="departureDate"
            label="Дата на приключване"
            noTime
            required={true}
            validate={required()}
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default CheckFinishedModal;
